import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRail.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseCreditsMeterProps {
  left: number;
  limit: number;
  thin?: boolean;
  className?: string;
}

/**
 * The credits left as a bar (design a1). With one credit or none left the bar turns amber (b7).
 * The fill width is the only inline style: it is data, not layout.
 */
const BrowseCreditsMeterComponent: React.FC<BrowseCreditsMeterProps> = ({ left, limit, thin, className }) => {
  const share = limit > 0 ? Math.max(0, Math.min(1, left / limit)) : 0;
  return (
    <div
      className={clsx(styles.meter, thin === true && styles.meterThin, left <= 1 && styles.meterWarn, className)}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={limit}
      aria-valuenow={left}
    >
      <span className={styles.meterFill} style={{ width: `${share * 100}%` }} />
    </div>
  );
};

export const BrowseCreditsMeter = TypedMemo(BrowseCreditsMeterComponent);
